import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { blogs } from '../data/blogs';

const ContentBlock = ({ block }) => {
  if (block.type === 'image') {
    return (
      <div className="my-6">
        <img src={block.src} alt={block.alt || ''} className="rounded-xl w-full object-cover" />
      </div>
    );
  }
  if (block.type === 'quote') {
    return (
      <blockquote className="my-8 border-l-4 border-[#3C0F6C] pl-6 text-2xl font-semibold text-gray-800 italic">
        “{block.text}”
      </blockquote>
    );
  }
  return <p className="my-4 text-gray-700 leading-7">{block.text}</p>;
};

const Related = ({ currentSlug }) => {
  const related = blogs.filter(b => b.slug !== currentSlug).slice(0, 4);
  return (
    <section className="mt-12 bg-gray-50 border rounded-2xl p-6">
      <h3 className="text-lg font-semibold mb-4">Related Posts</h3>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {related.map(post => (
          <Link key={post.slug} to={`/blogs/${post.slug}`} className="block bg-white rounded-xl overflow-hidden border hover:shadow">
            <div className="aspect-[16/9] overflow-hidden">
              <img src={post.coverImage} alt={post.title} className="w-full h-full object-cover" />
            </div>
            <div className="p-3">
              <div className="text-xs text-gray-500">{new Date(post.date).toLocaleDateString()}</div>
              <div className="text-sm font-medium line-clamp-2">{post.title}</div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

const BlogDetail = () => {
  const { slug } = useParams();
  const post = blogs.find(b => b.slug === slug);

  if (!post) {
    return (
      <div className="py-16">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-2">Post not found</h1>
          <p className="text-gray-600 mb-4">The article you are looking for doesn’t exist.</p>
          <Link to="/blogs" className="text-[#3C0F6C] font-semibold">Back to Blogs</Link>
        </div>
      </div>
    );
  }

  return (
    <article className="pb-10">
      {/* Header banner */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-16">
        <div className="relative overflow-hidden rounded-2xl sm:rounded-3xl border">
          <div className="h-56 sm:h-72 md:h-96 w-full">
            <img src={post.coverImage} alt={post.title} className="w-full h-full object-cover" />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
          <div className="absolute bottom-0 p-4 sm:p-6 md:p-10 text-white">
            <h1 className="text-2xl sm:text-3xl md:text-5xl font-extrabold max-w-3xl">{post.title}</h1>
            <p className="mt-2 text-white/80 max-w-xl text-sm sm:text-base">{post.excerpt}</p>
            <div className="mt-3 text-xs sm:text-sm text-white/80 flex flex-wrap items-center gap-2 sm:gap-3">
              <span>By {post.author}</span>
              <span>•</span>
              <span>{new Date(post.date).toLocaleDateString()}</span>
              <span>•</span>
              <span>{post.readTime} min read</span>
            </div>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="max-w-3xl md:max-w-4xl lg:max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mt-8">
          {post.content?.map((block, idx) => (
            <ContentBlock key={idx} block={block} />
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-16">
        <Related currentSlug={post.slug} />
      </div>
    </article>
  );
};

export default BlogDetail;
